import { Access } from "../../../../access/types.ts";
import {
  aliasParameter,
  parentParameter,
  requiredProviderParameter,
  sudoParameter,
} from "./parameters.ts";

export const commonParentAccess = Access({
  description: "All resources a parent can access",
  label: "SSH Parent",
  maturity: "ga",
  delegation: {},
  generated: {},
  parameters: {
    sudo: sudoParameter,
    provider: { ...requiredProviderParameter, optional: true },
    parent: { ...parentParameter, optional: undefined },
    alias: aliasParameter,
  },
  render: { locator: "parent", policy: "sudo" } as const,
});
